export default __webpack_public_path__ + "static/media/durvis-9-min.cde7ecd2.jpg";